import * as React from 'react';
import styles from './MarkdownContent.module.css';

type MarkdownContentProps = {
  markdown: string;
};

const MarkdownContentImpl = React.lazy(() => import('./MarkdownContentImpl'));

export const MarkdownContent = React.memo(function MarkdownContent({ markdown }: MarkdownContentProps) {
  return (
    <React.Suspense
      fallback={<div className={`${styles.prose} ${styles.proseFallback}`}>{markdown}</div>}
    >
      <MarkdownContentImpl markdown={markdown} />
    </React.Suspense>
  );
});
